import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import AsyncGoogleOAuthProvider from './components/AsyncGoogleOAuthProvider';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { registerServiceWorker, captureInstallPrompt, isRunningAsInstalledClient, markPwaInstalled } from './utils/pwa';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// Filtro de errores globales en desarrollo para evitar que errores externos
// (scripts de navegador/extensiones) rompan el overlay de React.
if (process.env.NODE_ENV === 'development') {
  const shouldIgnoreError = (source, message, stack) => {
    const src = String(source || '').toLowerCase();
    const msg = String(message || '').toLowerCase();
    const stk = String(stack || '').toLowerCase();

    // Si el stack/filename NO menciona nuestro código fuente, y el mensaje es genérico,
    // asumimos que viene de un script externo (extensión, devtools, etc).
    const isFromOurCode =
      src.includes('/src/') ||
      src.includes('localhost') ||
      stk.includes('/src/') ||
      stk.includes('localhost');

    if (isFromOurCode) return false;

    if (msg.includes('failed to fetch')) {
      return true;
    }

    // Web Vitals / DevTools / extensiones (stack anónimo VMxx)
    if (
      msg.includes("reading 'starttime'")
      || (msg.includes('starttime') && !isFromOurCode)
    ) {
      return true;
    }

    // Patrones típicos que estás viendo
    if (src.includes('ewe-content') || src.includes('apex') || src.includes('toolset')) {
      return true;
    }
    if (msg.includes('internal error') || msg.includes('unknownerror')) {
      return true;
    }

    return false;
  };

  window.addEventListener('error', (event) => {
    if (shouldIgnoreError(event.filename, event.message, event.error?.stack)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason || {};
    const message = reason.message || String(reason);
    const stack = reason.stack || '';
    if (shouldIgnoreError('', message, stack)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const msg = String(message).toLowerCase();
    const fromUs =
      String(stack).includes('/src/') ||
      String(stack).includes('bundle.js') ||
      String(stack).includes('localhost');
    if (fromUs && msg.includes('failed to fetch')) {
      console.warn('[Contsuite] API no alcanzable. ¿Backend en marcha? cd backend && npm start');
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AsyncGoogleOAuthProvider>
      <AuthProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AuthProvider>
    </AsyncGoogleOAuthProvider>
  </React.StrictMode>
);

captureInstallPrompt();
registerServiceWorker();
if (isRunningAsInstalledClient()) {
  markPwaInstalled();
}
